/* eslint-disable @typescript-eslint/no-magic-numbers */
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
  WritableSignal,
  signal,
} from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

import { debounceTime, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { TAMAM_MAX_INSTALLMENTS } from '../tamam-promo/tamam-promo.component';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaCheckoutService } from '@app/akita/api/checkout/state/checkout.service';

@Component({
  standalone: true,
  selector: 'popsy-tamam-overview',
  templateUrl: './tamam-overview.template.html',
  styleUrls: ['./tamam-overview.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    RouterModule,
    TranslocoModule,
  ],
})
export class TamamOverviewComponent implements OnDestroy, OnChanges {
  @Input() public listingId?: string | null;
  @Input() public amount?: number | null;
  @Input() public currency?: string | null;

  public maxInstallments: number | null;
  public splitAmount: string | null;

  public readonly nationalIdFormControl: UntypedFormControl;
  public isIdValid: WritableSignal<boolean | null> = signal(null);

  public rtl$: Observable<boolean>;

  public readonly language$: Observable<string>;

  private readonly subscriptions: Subscription;
  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly translateService: TranslocoService,
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly akitaCheckoutService: AkitaCheckoutService
  ) {
    // private readonly tamamActionsService: TamamActionsService,

    this.destroySubject = new Subject();
    this.subscriptions = new Subscription();

    this.language$ = this.translateService.langChanges$;
    this.rtl$ = this.akitaRouterQuery.selectIsRtlLayout();

    this.splitAmount = ((this.amount || 0) / TAMAM_MAX_INSTALLMENTS).toFixed(2);

    this.maxInstallments = TAMAM_MAX_INSTALLMENTS;

    this.nationalIdFormControl = new UntypedFormControl('', {
      validators: Validators.compose([]),
      updateOn: 'change',
    });

    this.subscriptions.add(
      this.nationalIdFormControl.valueChanges
        .pipe(debounceTime(500), takeUntil(this.destroySubject))
        .subscribe({
          next: (value) => {
            if (/^\d{10}$/.test(value)) {
              this.akitaCheckoutService.setTamamNationalId(value);
              this.isIdValid.set(true);
            } else {
              this.akitaCheckoutService.setTamamNationalId(null);
              this.isIdValid.set(false);
            }
          },
        })
    );
  }
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.splitAmount = ((this.amount || 0) / TAMAM_MAX_INSTALLMENTS).toFixed(2);
    }
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();

    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
